import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getOrderItems, getOrderShowtimes, orderHasInProgressAction, removeOrderItem } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback, useState } from 'react';
import { Button } from '../../subcomponents/button/button';
import { ButtonColor } from '../../subcomponents/button/types/color';
import { ButtonIconPosition } from '../../subcomponents/button/types/icon-position';
import { ButtonSize } from '../../subcomponents/button/types/size';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { OrderTotals } from '../order-totals/order-totals';
import { OrderCartItemList } from './subcomponents/item-list';
import { OrderCartShowtimeList } from './subcomponents/showtime-list';
import { mapOrderCartContext, OrderCartContextInstance } from './types/context';
import { defaultOrderCartProps, orderCartPropsValidator } from './types/props';
const b = bemClassBuilder('v-order-cart');
export const OrderCart = observer(props => {
    const { displayText, config, events, assets } = props;
    const { items, actionButton } = config;
    const { onActionButtonClicked } = events;
    const [isActionLoading, setIsActionLoading] = useState(false);
    const orderShowtimes = getOrderShowtimes();
    const orderItems = getOrderItems();
    const handleItemRemoved = useCallback((orderItem) => {
        removeOrderItem(orderItem.id);
    }, []);
    const handleActionButtonClicked = useCallback(async () => {
        if (!onActionButtonClicked)
            return;
        setIsActionLoading(true);
        await onActionButtonClicked();
        setIsActionLoading(false);
    }, [onActionButtonClicked]);
    const disableRemoveButton = orderHasInProgressAction();
    return (_jsx(OrderCartContextInstance.Provider, Object.assign({ value: mapOrderCartContext(props) }, { children: _jsxs("div", Object.assign({ className: b.block({ withLabels: config.showLabels }) }, { children: [_jsx(OrderCartShowtimeList, { orderShowtimes: orderShowtimes }), items.show && (_jsx(OrderCartItemList, { orderItems: orderItems, onRemoveItem: handleItemRemoved, disableRemoveButton: disableRemoveButton })), _jsx(OrderTotals, Object.assign({}, props)), actionButton.show && (_jsx("footer", Object.assign({ className: b.element('footer', { showActionButton: actionButton.show }) }, { children: _jsx(Button, { className: b.element('action-button'), color: ButtonColor.Primary, size: ButtonSize.Large, label: displayText.actionButtonLabel, onClick: handleActionButtonClicked, iconName: assets.actionButtonIconName, iconPosition: ButtonIconPosition.Right, loading: isActionLoading }) })))] })) })));
});
OrderCart.displayName = 'OrderCart';
/**
 * The **Order Cart** component renders the order cart for a currently in-progress order.
 */
export const OrderCartComponent = withComponentWrapper(OrderCart, defaultOrderCartProps, orderCartPropsValidator);
